// import ModalForm from "./Form";
import InvoiceHistoryTableForm from "./InvoiceHistoryTableForm";
import InvoiceHistoryApproveForm  from "./InvoiceHistoryApproveForm";
import InvoiceHistoryRejectForm  from "./InvoiceHistoryRejectForm";
import {
    INVOICE_HISTORY_V2,
    DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const InvoiceHistoryTableSchema = {
    components: { InvoiceHistoryTableForm,InvoiceHistoryApproveForm,InvoiceHistoryRejectForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            Endpoint: INVOICE_HISTORY_V2 + "?clc_id_number=" + this.value.clc_id_number,
            tableId: "invoice-history-table",
            formId: "invoice-history-table-form",
            formIdApprove: "invoice-history-approve-form",
            formIdReject: "invoice-history-reject-form",
            rowData: {},
            tableColumns: [
                {
                    title: "Request By",
                    type: "custom-html",
                    key: "request_user_id",
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            return value.full_name
                        } else {
                            return ""
                        }
                    }
                },
                {
                    title: "Request Date",
                    type: "text",
                    key: "request_date",
                },
                {
                    title: "Invoice Request ID",
                    type: "text",
                    key: "request_no",
                },
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    isVisible: true,
                    modifier: (value) => {
                        return value ? value.academic_calendar_name : '-'
                    },
                },
                {
                    title: "Invoice Status",
                    type: "custom-html",
                    key: "status",
                    isVisible: true,
                    modifier: (value, rowData) => {
                        const dueDate = rowData.due_date;
                        const today = new Date().toISOString().slice(0, 10);
                        if (value) {
                            
							let ClassName = "danger";
                            let status = rowData.status;
                            if (value === "Waiting Approval AC") {
								ClassName = `primary`;
                                status = 'Awaiting Approval';
							} else if (value === "Paid") {
								ClassName = `success`;
							} else if (value === "UnPaid") {
								ClassName = `danger`;
							} else if (value === "Cancelled" || value === "Deleted"  || value === "Rejected" || value === "Rejected By AC") {
								ClassName = `danger`;
                            } else if(dueDate < today) {
                                status = 'Voided';
								ClassName = `danger`;
							} else if (value === "Waiting Approval Finance" && rowData.invoice_payment_status== 0) {
								ClassName = `primary`;
                                status = 'InProgress';
							}else if (value === "Waiting Approval Finance" && rowData.invoice_payment_status== 1) {
								ClassName = `primary`;
                                status = 'Payable';
							}  else if (value === "Requested") {
								ClassName = `warning`;
							} else if (value === "Processed") {
								ClassName = `secondary`;
							} else if (value === "Invoiced") {
								ClassName = `primary`;
							} 

                            let statusHtml = `
                                        <div class="text-center">
                                            <span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
                            if(value == 'UnPaid'){
                                statusHtml +=`<br>${rowData.approval_note}`;
                            }
                                
                            if (value === "Waiting Approval Finance" && this.can('approval_finance') && rowData.invoice_payment_status == 1 && dueDate >= today && value != "Cancelled" || value === "Processed") {
                                    statusHtml += `
                                    <div style="margin-top: 5px;">
                                        <button class="btn btn-success btn-sm" title="Approve"  onclick="window.__approveInvoice('${rowData.id}')"><i class="fa fa-check"></i></button>
                                        <button class="btn btn-danger btn-sm" title="Reject"  onclick="window.__rejectInvoice('${rowData.id}')"><i class="fa fa-times"></i></button>
                                    </div>
                                    `;
                                }

                            statusHtml += `</div>`; 

                            return statusHtml;
                        }
                    },
                },
                {
                    title: "Completed By",
                    type: "text",
                    key: "completed_user_id",
                },
                {
                    title: "Action",
					type: "custom-html",
 			 		key: "id", 
					modifier: (value, rowData) => {

                        var disableEdit = '';
                        if(rowData.status !='Waiting Approval Finance' && rowData.status !='Requested' && rowData.status !='Processed' ){
                            disableEdit = true;
                        }
                        var btn = '';
                        if(this.can('update_finance')){
                            btn+=`
                                <button 
                                    data-toggle="tooltip"
                                    title="Edit"
                                    class="btn btn-success" 
                                    style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
                                    onclick="window.handleBtnEdit(${rowData.id})"
                                    ${disableEdit ? "disabled" : ""}
                                >
                                    <i class="fa fa-edit"></i>
                                </button>`;
                        }
                        btn +=`
                                <button 
                                    data-toggle="tooltip"
                                    title="View"
                                    class="btn btn-success" 
                                    style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
                                    onclick="window.handleBtnView(${rowData.id})"
                                >
                                    <i class="fa fa-eye"></i>
                                </button>
                                <button 
                                    title="download"
                                    data-toggle="tooltip"
                                    class="btn btn-success" 
                                    style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
                                    onclick="window.handleBtnDownloadPDF(${rowData.id})"
                                >
                                    <i class="fa fa-download"></i>
                                </button>
                                <button 
                                    title="Send Mail"
                                    data-toggle="tooltip"
                                    class="btn btn-success" 
                                    style="border-radius: 50% !important; padding: 0.4rem 0.5rem;"
                                    onclick="window.handleBtnSendMail(${rowData.id})"
                                >
                                    <i class="fa fa-envelope"></i>
                                </button>
                        `;
                        return btn;
                    }
                },
                {
                    title: "Fees Notice ID",
                    type: "text",
                    key: "invoice_no",
                },
                {
                    title: "Print Date",
                    type: "text",
                    key: "request_print_date",
                },
                {
                    title: "Due Date",
                    type: "text",
                    key: "due_date",
                },
            ],
            options: {
                name: "InvoiceHistoryTable",
                url: INVOICE_HISTORY_V2 + "?clc_id_number=" + this.value.clc_id_number,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    // {
                    //     title: this.$t("edit"),
                    //     icon: "edit",
                    //     type: "page",
                    //     url: (rowData) => `transaction/profile-student/invoice/invoice-request-v2/${rowData.id}`,
                    //     target: "", // _blank to open newtab
                    //     uniqueKey: (rowData) => rowData.id,
                    //     disabled: (rowData) => this.isButtonDisabled(rowData)
                    // },
                    // {
                    //     title: this.$t("view"),
                    //     icon: "eye",
                    //     type: "page",
                    //     url: "invoice/invoice-request-v2/view",
                    //     target: "",
                    //     uniqueKey: (rowData) => rowData.id,
                    //     disabled: (rowData) => this.isButtonDisabled(rowData)
                    // },
                    // {
                    //     title: 'Print',
                    //     icon: "file",
                    //     type: "page",
                    //     disabled: (rowData) => this.isButtonDisabled(rowData)
                    // },
                ],
                actions2: [
                    // {
                    //     title: this.$t("delete"),
                    //     icon: "trash",
                    //     type: "none",
                    //     component: "app-confirmation-modal",
                    //     modalId: "demo-delete",
                    //     disabled: (rowData) => this.isButtonDisabled(rowData)
                    // },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 3,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        isButtonDisabled(rowData) {
            return rowData.status.toLowerCase() === "deleted";
        }
    },
};
